'use client';

import { PageError, type RouteErrorProps } from './error-screens';

/** The floor's error state, for every route without a boundary of its own (docs/LOADING.md tool 10; `src/app/error-screens.tsx`). */
export default function RouteError(props: RouteErrorProps) {
  return <PageError {...props} frame="floor" />;
}
